import React, { useState } from "react";

export default function SectionToggle({ titulo, children }) {
  const [abierto, setAbierto] = useState(false);

  return (
    <div className="section-toggle mb-3">

      <button
        type="button"
        className={`section-toggle-button ${
          abierto ? "activo" : ""
        }`}
        onClick={() => setAbierto(!abierto)}
      >
        <span>{titulo}</span>

        <span className="section-toggle-icon">
          {abierto ? "−" : "+"}
        </span>
      </button>

      {abierto && (
        <div className="section-toggle-content">
          {children}
        </div>
      )}

    </div>
  );
}